import { readPartnerSource } from '@/lib/partner/attribution'
import { registerPostHogSuperProperties } from '@/utils/posthog'
import { pushToDataLayer } from '@/utils/gtm'

// Once-per-session guard: without it a remount of the effect that calls
// registerPartnerAttribution() (React StrictMode double-invoke, a Suspense
// boundary re-render, etc.) would register the super-property and push the
// dataLayer value more than once.
let partnerAttributionRegistered = false

// Tags the current session with the partner it arrived through, once, so
// analytics can compute session-level conversion rate for a partner (not
// just booking-level attribution). Must be a strict no-op — no super
// property registered, no dataLayer push, nothing sent anywhere — when
// there is no roave_partner cookie, since this runs on every host
// including www.letsroave.com.
export const registerPartnerAttribution = (): void => {
  if (partnerAttributionRegistered) return

  let partner: string | undefined
  try {
    partner = readPartnerSource()
  } catch (error) {
    console.warn('Partner attribution lookup failed', error)
    return
  }

  if (!partner) return

  partnerAttributionRegistered = true

  try {
    void registerPostHogSuperProperties({ partner })
  } catch (error) {
    console.warn('Partner PostHog attribution failed', error)
  }

  try {
    pushToDataLayer({ partner })
  } catch (error) {
    console.warn('Partner GTM attribution failed', error)
  }
}
